export default "https://cdn-static.gokick.com/assets/0488227f5b7e53bbf90738be35137ce008cd4a94/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";